import React, {  } from 'react'
import PropTypes from 'prop-types'
import Box from '../../components/Box'

const CodeElement = ({children, showFields, customCodeProps, name: ComponentName}) => {
    let prs
    if (!Array.isArray(children)) {
        prs = [children]
    } else {
        prs = children
    }
    return <>{prs.map((ch, index) => {
        const { name, displayName } = ch.type
        const pr = ch.props
        const childName = (ComponentName || displayName || name).replace('__', '.')
        return <div key={childName+index}>
            <Box>{'<' + childName}</Box>
            <Box paddingLeft='1em'>
                {Object.keys(pr).map((key) => {
                    const value = pr[key]
                    const divKey = `element_key_${key}`
                    const customCodeProp = customCodeProps.find((prop) => prop.name === key)
                    if (customCodeProp){
                        return (<Box color='black' key={divKey}><b style={{ color: 'red', fontWeight: 'bolder' }}>{key}</b>={'{' +  customCodeProp.value + '}'}</Box>)
                    }
                    if (key === 'children' || value === null || value === undefined || value === '' || key === 'THEME') {
                        return null
                    }
                    if (typeof value === 'function') {
                        if (!showFields) {
                            return null
                        }
                        /* istanbul ignore next */
                        const valName = value.displayName || value.name
                        /* istanbul ignore next */
                        return valName
                            ? (<Box color='#888' key={divKey}><b style={{ color: '#F88', fontWeight: 'bolder' }}>{key}</b>='{valName.replace('__', '.')}'</Box>)
                            : null
                    }
                    if (Array.isArray(value)) {
                        const valArray = '{[' + value.map(v => `'${v}'`).join(',') + ']}'
                        return (<Box color='black' key={divKey}><b style={{ color: 'red', fontWeight: 'bolder' }}>{key}</b>={valArray}</Box>)
                    }
                    if (typeof value === 'boolean') {
                        if (!value) {
                            return null
                        }
                        return (<Box key={divKey} color='red' fontWeight='bolder'>{key}</Box>)
                    }
                    if (typeof value === 'number') {
                        return (<Box color='black' key={divKey}><b style={{ color: 'red', fontWeight: 'bolder' }}>{key}</b>={'{' + value.toString() + '}'}</Box>)
                    }
                    if (typeof value === 'object') {
                        try {
                            if (JSON.stringify(value) === '{}') {
                                return null
                            }
                        } catch {
                            /* istanbul ignore next */
                            return (<Box color='black' key={divKey}><b style={{ color: 'red', fontWeight: 'bolder' }}>{key}</b>=Object</Box>)
                        }
                        return (<Box color='black' key={divKey} width='80%'><b style={{ color: 'red', fontWeight: 'bolder' }}>{key}</b>=<span style={{whiteSpace: 'pre-line'}}>{'{' + JSON.stringify(value, null, ' ') + '}'}</span></Box>)
                    }
                    return (<Box color='black' key={divKey}><b style={{ color: 'red', fontWeight: 'bolder' }}>{key}</b>='{value.toString()}'</Box>)
                }
                )}
            </Box>
            <Box>{pr['children']
                ? '>' + pr['children'] + '</' + childName + '>'
                : '/>'
            } </Box>
        </div>
    })}</>
}

CodeElement.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.element),
    ]),
    name: PropTypes.string,
    width: PropTypes.string,
    customCodeProps: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.string
    })),
    showFields: PropTypes.bool,
}
CodeElement.defaultProps = {
    name: null,
    width: '300px',
    customCodeProps: [],
    showFields: false
}
export default CodeElement
